<template>
  <div class="hotels">
    <SidebarLayout2
      :breadcrumb="breadcrumb"
      :rootPath="rootPath"
      :pageTitle="pageTitle"
      class="hotels--sidebar"
    >
      <!-- BARRA LATERAL -->
      <template #sidebar class="sidebar">
        <SidebarBlock class="menu-wrapper">
          <!-- MENU DOS HOTÉIS -->
          <PmwHotelNav
            :disabled="hotelId ? false : true"
            :hide="[
              ...(selectedHotels[0]?.tarifarioAbsoluto
                ? ['diferenciais', 'banners']
                : ['banners']),
              ...(!selectedHotels[0]?.exibePontos ? ['pontos'] : [])
            ]"
            :links="menuLinks"
            :tooltipText="
              selectedHotels.length === 0
                ? 'Selecione um hotel para ativar os atalhos.'
                : 'Não é possivel usar os atalhos com mais de um hotel selecionado.'
            "
          />
        </SidebarBlock>
        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="page-actions">
          <PmwHeading
            v-if="isEditor"
            class="sidebar--title"
            size="paragraph-80"
            weight="weight-medium"
          >
            Ações da página
          </PmwHeading>
          <!-- CADASTRAR -->
          <PmwButton
            v-if="isEditor"
            :hasIcon="true"
            link="/hoteis/novo"
            variation="pmw-primary"
            element="router-link"
            class="sidebar--button"
          >
            Cadastrar hotel
          </PmwButton>
        </SidebarBlock>
      </template>

      <!-- CONTEÚDO -->
      <template #content>
        <!-- BUSCA DO NOME DO HOTEL -->
        <SearchInput
          v-model="searchTerm"
          :disabled="true"
          placeholder="Buscar hotel"
          class="search-term"
          @input="searchData"
        />

        <div class="filters">
          <!-- FILTRO POR STATUS -->
          <FilterDropdown
            v-model="status"
            :options="statusList"
            :hasSearch="true"
            :toggleAll="true"
            :radioOptions="false"
            toggleAllLabel="Todas"
            checkboxNoSelectionLabel="Todas"
            label="Status"
            searchFieldPlaceholder="Pesquisar status"
            class="filters--item filters--item__status"
            @input="searchData"
          />

          <!-- FILTRO POR CIDADE -->
          <FilterDropdown
            v-model="city"
            :options="cityList"
            :hasSearch="true"
            :toggleAll="true"
            :radioOptions="false"
            toggleAllLabel="Todas"
            checkboxNoSelectionLabel="Todas"
            label="Cidade"
            searchFieldPlaceholder="Pesquisar cidade"
            class="filters--item filters--item__city"
            @input="searchData"
          />

          <!-- FILTRO POR ESTADO (UF) -->
          <FilterDropdown
            v-model="state"
            :options="stateList"
            :hasSearch="true"
            :toggleAll="true"
            :radioOptions="false"
            toggleAllLabel="Todas"
            checkboxNoSelectionLabel="Todas"
            label="UF"
            searchFieldPlaceholder="Pesquisar UF"
            class="filters--item filters--item__state"
            @input="searchData"
          />
        </div>

        <!-- DADOS DA TABELA -->
        <DataTable
          :cols="gridColumns"
          :rows="rows"
          :selectableRow="true"
          :isLoading="isLoadingTableContent"
          :colsMinWidths="colsWidths"
          :selectedRowHasBgColor="true"
          class="datatable"
          ref="datatable"
          notFoundMessage="Não há hotéis com a busca."
          @getSelectedRows="manageSelectedRooms"
        >
          <!-- NOME DO HOTEL -->
          <template v-if="isEditor" v-slot:hotel="slotProps">
            <router-link
              :to="`/hoteis/editar/${slotProps.rowDataObj.codigo}`"
              class="datatable--link"
            >
              {{ slotProps.rowDataObj.hotel }}
            </router-link>
          </template>

          <!-- STATUS DO HOTEL -->
          <template v-slot:status="slotProps">
            <span>{{
              slotProps.rowDataObj.status === true ? 'Ativo' : 'Inativo'
            }}</span>
          </template>
        </DataTable>

        <!-- PAGINAÇÃO -->
        <PmwPagination
          :currentPage="pagination.currentPage"
          :items="hotelsFiltered"
          :itemsPerPage="pagination.itemsPerPage"
          :itemsPerPageOptions="pagination.itemsPerPageOptions"
          :totalItems="hotelsFiltered.length"
          @changePagination="changePagination"
        />

        <!-- MODAL DE LIMPAR OS DADOS DE PRÉ-PRODUÇÃO -->
        <PmwAlertModal
          :value="getModalClearPreProduction"
          :closeButton="true"
          title="Tem certeza que deseja limpar os dados para pré-produção?"
          iconColor="red-100"
          cancelButtonColor="red-100"
          confirmButtonColor="red-100"
          icon="trash-can"
          confirmButtonText="Limpar dados"
          cancelButtonText="Cancelar"
          class="pmw-alert-modal"
          @alert-modal-confirm="clearPreProduction"
          @alert-modal-cancel="setModalClearPreProduction(false)"
        >
          <template #text>
            Ao limpar, os dados de demonstração serão todos <br />
            excluídos, não podendo serem ativados novamente.
          </template>
        </PmwAlertModal>

        <!-- MODAL DE DELETAR O PRIMEIRO HOTEL -->
        <PmwAlertModal
          :value="getModalDeleteFirstHotel"
          :closeButton="true"
          title="Tem certeza que deseja deletar o  hotel de demonstração?"
          iconColor="red-100"
          cancelButtonColor="red-100"
          confirmButtonColor="red-100"
          icon="trash-can"
          confirmButtonText="Deletar hotel"
          cancelButtonText="Cancelar"
          class="pmw-alert-modal"
          @alert-modal-confirm="deleteFirstHotel"
          @alert-modal-cancel="setModalDeleteFirstHotel(false)"
        >
          <template #text>
            Ao deletar o primeiro hotel, ele não poderá<br />
            mais ser utilizado para testes.
          </template>
        </PmwAlertModal>
      </template>
    </SidebarLayout2>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SidebarLayout2 from '@/layouts/SidebarLayout2'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import SearchInput from '@solucoes/components-lib-tmp/src/components/elements/SearchInput'
import FilterDropdown from '@solucoes/components-lib-tmp/src/components/patterns/FilterDropdown'
import DataTable from '@solucoes/components-lib-tmp/src/components/patterns/DataTable'
import PmwPagination from '@solucoes/components-lib-tmp/src/components/patterns/PmwPagination'
import PmwAlertModal from '@solucoes/components-lib-tmp/src/components/patterns/PmwAlertModal'

import hotelCommonsMixin from '@/mixins/hotelCommonsMixin'

export default {
  name: 'HotelList',

  mixins: [hotelCommonsMixin],

  components: {
    SidebarLayout2,
    SidebarBlock,
    PmwHeading,
    PmwButton,
    SearchInput,
    FilterDropdown,
    DataTable,
    PmwPagination,
    PmwAlertModal
  },

  data() {
    return {
      exibePontos: false,

      /** Configuração da página */
      pageTitle: 'Listagem de hotéis',

      /** Caminhos da página */
      rootPath: {
        /** ponto de partida do breadcrumb  */
        label: 'Home',
        url: 'relatorio-conversao',
        isSpa: false /** se deve ser um link para o site novo ou antigo */
      },

      /** Caminho de pão */
      breadcrumb: [
        {
          label: 'Letsbook',
          url: '',
          isSpa: false
        },
        {
          label: 'Hotéis',
          url: '/',
          isSpa: false
        }
      ],

      /** Termo para pesquisa */
      searchTerm: null,

      /** Filtrar por status */
      status: [
        {
          value: true,
          label: 'Ativo'
        }
      ],

      /** Lista de status */
      statusList: [
        {
          value: true,
          label: 'Ativo'
        },
        {
          value: false,
          label: 'Inativo'
        }
      ],

      /** Colunas da tabela */
      gridColumns: [
        { name: 'hotel', alias: 'Hotel' },
        { name: 'cidade', alias: 'Cidade' },
        { name: 'uf', alias: 'UF' },
        { name: 'status', alias: 'Situação' }
      ],

      /** Linhas paginadas */
      rows: [],

      /** Dados para paginação */
      pagination: {
        currentPage: 1,
        itemsPerPage: 25,
        itemsPerPageOptions: [
          {
            text: '25',
            value: 25
          },
          {
            text: '50',
            value: 50
          },
          {
            text: '75',
            value: 75
          },
          {
            text: '100',
            value: 100
          }
        ]
      },

      /** Larguras das colunas */
      colsWidths: {
        cidade: '205px',
        uf: '80px',
        status: '90px'
      },

      /** Hotéis selecionados */
      selectedHotels: [],

      /** Hotel selecionado */
      selectedHotel: null,

      /** Loader da tabela */
      isLoadingTableContent: true,

      /** Lista de quartos */
      hotels: [],

      /** Lista de quartos filtrada */
      hotelsFiltered: [],

      /** Opções de cidades */
      cityList: [],

      /** Cidades selecionadas */
      city: [],

      /** Opções de UF */
      stateList: [],

      /** UF selecionados */
      state: [],

      /** Se o usuário tem permissão para editar o hotel */
      isEditor: false,

      /** Modal de limpar os dados de pré-produção */
      modalClearPreProduction: false,

      /** Modal de deletar o hotel de demonstração */
      modalDeleteFirstHotel: false
    }
  },

  watch: {
    /** Observar os hotéis selecionados na tabela */
    selectedHotels() {
      /** Verificar se há apenas um item selecionado */
      if (this.selectedHotels.length === 1) {
        this.selectedHotel = this.selectedHotels[0]
        this.hotelId = this.selectedHotel.codigo
      } else {
        this.selectedHotel = null
        this.hotelId = null
      }
    }
  },

  computed: {
    ...mapGetters('hotel', [
      'getModalClearPreProduction',
      'getModalDeleteFirstHotel'
    ]),

    ...mapGetters('user', ['getPermissions'])
  },

  created() {
    /** Verificar se o usuário possui acesso para editar os hotéis */
    this.checkUserPermission()

    /** Pegar o hotel */
    this.getHotels()

    /** Verificar se o cliente está em produção */
    if (this.isEditor) this.getClientProd()
  },

  /** Antes de sair da tela de hotéis */
  beforeRouteLeave(to, from, next) {
    this.setButtonDeleteFirstHotel(false)
    this.setButtonClearPreProduction(false)

    next()
  },

  methods: {
    /** Verificar se o usuário possui acesso para editar os hotéis */
    checkUserPermission() {
      /** Checar se a permissão faz parte do token do usuário */
      this.isEditor = this.getPermissions.includes('lb.hot.edit') ? true : false
    },

    /** Buscar hotel */
    getHotels() {
      this.$hotel
        .get()
        .then((response) => {
          /** Formatar os dados dos hotéis */
          this.hotels = response.data.map((hotel) => {
            const item = {
              data: {
                codigo: hotel.codigo,
                hotel: hotel.nome,
                cidade: hotel.endereco?.nomeCidade,
                uf: hotel.endereco?.codigoEstado,
                status: hotel.ativo,
                tarifarioAbsoluto: hotel.tarifarioAbsoluto,
                exibePontos: hotel.exibeCalendarioPontos
              }
            }
            return item
          })

          /** Esconder loading */
          this.isLoadingTableContent = false

          /** Filtrar dados */
          this.searchData()

          /** Compor filtro de cidades */
          this.getCities(this.hotels.map((item) => item.data.cidade))

          /** Compor filtro de estados */
          this.getStates(this.hotels.map((item) => item.data.uf))

          /** Verificar se existe o primeiro hotel de teste, e se for administrador */
          if (
            this.hotels.filter((hotel) => hotel.data.hotel === 'PRIMEIRO HOTEL')
              .length &&
            this.isEditor
          ) {
            /** Exibir botão de deletar primeiro hotel */
            this.setButtonDeleteFirstHotel(true)
          }
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Houve um erro ao buscar os hotéis.'
          })
        })
    },

    /** Compor filtro de cidades
     * @param {Array} cities - Cidades presentes na busca
     */
    getCities(cities) {
      /** Remover as cidades duplicadas */
      cities = [...new Set(cities)]
      /** Formatar os dados para o filtro */
      this.cityList = cities.map((item) => {
        return {
          value: item,
          label: item
        }
      })
    },

    /** Compor filtro de estados
     * @param {Array} states - Códigos de estados presentes na busca
     */
    getStates(states) {
      /** Remover os códigos duplicadas */
      states = [...new Set(states)]
      /** Formatar os dados para o filtro */
      this.stateList = states.map((item) => {
        return {
          value: item,
          label: item
        }
      })
    },

    /** Selecionar os hotéis
     * @param {Array} values - Hotéis selecionados
     */
    manageSelectedRooms(values) {
      this.selectedHotels = values
    },

    /** Pesquisar hotéis */
    searchData() {
      /** Pesquisa pelo nome do hotel */
      const nameSearch = this.searchTerm ? this.searchTerm.toLowerCase() : false
      /** Pesquisa pela cidade */
      const citySearch = this.city.map((item) => item.value)
      /** Pesquisa pelo estado */
      const stateSearch = this.state.map((item) => item.value)
      /** Pesquisa pelo status do hotel */
      const statusSearch = this.status.map((item) => item.value)
      /** Pegar os hotéis filtrados */
      this.hotelsFiltered = this.hotels.filter(function(item) {
        /** Verificar se o nome é igual ao termo pesquisado */
        const searchName =
          !nameSearch || item.data.hotel.toLowerCase().includes(nameSearch)
            ? true
            : false
        /** Filtrar pelo status */
        const searchStatus =
          statusSearch.length === 0 || statusSearch.includes(item.data.status)
            ? true
            : false
        /** Filtrar pela cidade */
        const searchCity =
          citySearch.length === 0 || citySearch.includes(item.data.cidade)
            ? true
            : false
        /** Filtrar pelo estado */
        const searchState =
          stateSearch.length === 0 || stateSearch.includes(item.data.uf)
            ? true
            : false
        return searchName && searchStatus && searchCity && searchState
      })
    },

    /** Paginar
     * @param {Object} childData - dados da paginação que são retornados pelo componente
     */
    changePagination(childData) {
      /** Dados da tabela conforme a paginação */
      this.pagination.currentPage = childData.currentPage
      this.rows = childData.items
    },

    /** Verificar se o cliente está em produção (habilitar o botão para Limpar a pré-produção ou não) */
    getClientProd() {
      this.$hotel
        .getClientProd()
        .then((response) => {
          /** Se retornar "false", apresentar o botão de Limpar pré-produção */
          this.setButtonClearPreProduction(!response.data)
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Houve um erro ao verificar se o cliente está em produção.'
          })
        })
    },

    /** Limpar pré-produção */
    clearPreProduction() {
      this.$hotel
        .clearPreProduction()
        .then(() => {
          /** Feedback de sucesso */
          this.$bus.$emit('show-alert-chip', {
            message: 'Os dados de pré-produção foram limpos com sucesso!'
          })

          /** Esconder o botão para limpar pré-produção */
          this.setButtonClearPreProduction(false)

          /** Esconder a modal para limpar pré-produção */
          this.setModalClearPreProduction(false)

          /** Recarregar a listagem de hotéis */
          this.getHotels()
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Houve um erro ao limpar a pré-produção.'
          })

          /** Esconder a modal para limpar pré-produção */
          this.setModalClearPreProduction(false)
        })
    },

    /** Deletar primeiro hotel */
    deleteFirstHotel() {
      this.$hotel
        .deleteFirstHotel()
        .then(() => {
          /** Feedback de sucesso */
          this.$bus.$emit('show-alert-chip', {
            message: 'Primeiro hotel deletado com sucesso!'
          })

          /** Esconder o botão para deletar o primeiro hotel */
          this.setButtonDeleteFirstHotel(false)

          /** Esconder a modal para deletar o primeiro hotel */
          this.setModalDeleteFirstHotel(false)

          /** Recarregar a listagem de hotéis */
          this.getHotels()
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Houve um erro ao deletar o primeiro hotel.'
          })

          /** Esconder a modal para deletar o primeiro hotel */
          this.setModalDeleteFirstHotel(false)
        })
    },

    ...mapActions('hotel', [
      'setButtonClearPreProduction',
      'setButtonDeleteFirstHotel',
      'setModalClearPreProduction',
      'setModalDeleteFirstHotel'
    ])
  }
}
</script>

<style lang="scss" scoped>
::v-deep .lb-breadcrumb--link:nth-child(2) {
  cursor: default;
  pointer-events: none;
}
.sidebar {
  &--title {
    margin-bottom: 15px;
  }
  &--button {
    margin-bottom: 10px;
  }
  &--text {
    line-height: 21px;
  }
}

.search-term {
  max-width: 215px;
  margin-bottom: 20px;
}

.filters {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;

  &--item {
    max-width: 215px;
    ::v-deep > .pmw-dropdown--trigger-button {
      gap: 5px;
    }

    &__status {
      min-width: 190px;
    }

    &__city {
      min-width: 190px;
    }

    &__state {
      min-width: 153px;
    }
  }
}

.datatable {
  max-height: initial;

  &--link {
    font-size: font-size('size-small');
    cursor: pointer;
    color: pmw-colors('blue-100');

    &:hover {
      color: pmw-colors('blue-100');
      text-decoration: underline;
    }
  }

  ::v-deep {
    .pmw-td span {
      font-size: font-size('size-small');
      line-height: font-size('size-small');
      max-height: font-size('size-small');
    }

    .pmw-datatable--row__selected-color {
      .datatable--link {
        color: $white;

        &:hover {
          color: $white;
        }
      }
    }
    .pmw-td span {
      font-size: font-size('size-small');
      line-height: font-size('size-small');
      max-height: font-size('size-small');
    }
    .no-gutters > .pmw-col {
      padding-left: 13px;
      padding-right: 13px;
    }

    /** Largura - Cidade */
    .pmw-col.pmw-th:nth-child(3),
    .pmw-col.pmw-td:nth-child(3) {
      max-width: 205px;
    }

    /** Largura - Estado */
    .pmw-col.pmw-th:nth-child(4),
    .pmw-col.pmw-td:nth-child(4) {
      max-width: 80px;
    }

    /** Largura - Status */
    .pmw-col.pmw-th:nth-child(5),
    .pmw-col.pmw-td:nth-child(5) {
      max-width: 90px;
    }
  }
}
</style>
